import { SESSION_STORAGES_KEYS } from 'constants/sessionStorages'
import { useRedirectTo } from 'hooks/useRedirectTo'
import { useHistory, useLocation } from 'react-router-dom'
import { useLoginService } from 'services/useLoginService'
import { useIsSafeURL } from 'redesign/hooks/useIsSafeURL'
import { getQueryParamsValue, removeQueryParams } from 'utils'

interface redirectToUrlExternalWithUniqueTokenProps {
    refreshToken: string
    accessToken: string
    redirectToUrl: string
    uniqueAccess?: boolean
}

export function useRedirectExternalUniqueToken() {
    const location = useLocation()
    const history = useHistory()
    const { isSafeURL } = useIsSafeURL()
    const { generateUniqueToken } = useLoginService()
    const { verifyRedirectUrl, newRedirectFlow } = useRedirectTo()

    function verifyQueryParamsAndSaveSessionStorage() {
        const isUniqueToken = getQueryParamsValue(location, 'uniqueToken')

        const redirectToUrl = getQueryParamsValue(location, 'redirectTo')

        isUniqueToken && sessionStorage.setItem(SESSION_STORAGES_KEYS.UNIQUE_TOKEN, isUniqueToken)

        redirectToUrl && sessionStorage.setItem(SESSION_STORAGES_KEYS.REDIRECT_TO_URL, redirectToUrl)
        if (!newRedirectFlow) {
            removeQueryParams(location, ['uniqueToken'], history)
        }
    }

    async function redirectToUrlExternalWithUniqueToken({
        accessToken,
        refreshToken,
        redirectToUrl,
        uniqueAccess = false,
    }: redirectToUrlExternalWithUniqueTokenProps) {
        try {
            const { token } = await generateUniqueToken({
                accessToken,
                refreshToken,
            })

            const redirectNewUrl = `${redirectToUrl}?u=${token}`
            if (uniqueAccess) {
                if (isSafeURL(redirectToUrl)) {
                    window.open(redirectNewUrl, '_self')
                } else {
                    console.error('Tentativa de redirecionamento para domínio não permitido:', redirectNewUrl)
                }
            } else {
                verifyRedirectUrl({ redirectToUrl })
            }

            sessionStorage.removeItem(SESSION_STORAGES_KEYS.UNIQUE_TOKEN)
            sessionStorage.removeItem(SESSION_STORAGES_KEYS.UNIQUE_ACCESS)
            sessionStorage.removeItem(SESSION_STORAGES_KEYS.REDIRECT_TO_URL)
            return
        } catch (error) {
            console.error(error)
        }
    }

    return {
        verifyQueryParamsAndSaveSessionStorage,
        redirectToUrlExternalWithUniqueToken,
    }
}
